module.exports = __webpack_public_path__ + "img/coderbot_wide3.d2ab4ca3.jpg";